export interface FlowItem {
    id: string;
    type: FlowItemType;
    name?: string;
    incoming?: string | string[];
    outgoing?: string | string[];
    visited?: boolean;
    discarded?: boolean;
    hideBackButton?: boolean;
}

export enum FlowItemType {
    Event = 'event',
    Task = 'task',
    ExclusiveGateway = 'exclusivegateway',
    Sequence = 'sequence',
    Process = 'process',
    SubProcess = 'subprocess'
}
